export function PrimaryComparison() {
  return (
    <div className="primary-comparison" aria-label="Adaptive LoRA compared with untuned Base Thinking on 400 held-out examples">
      <div className="chart-legend" aria-hidden="true">
        <span><i className="legend-base" />Base Thinking</span>
        <span><i className="legend-adaptive" />Adaptive LoRA</span>
      </div>

      <div className="paired-bars" role="img" aria-label="Mean reasoning tokens fell from 2031.8 to 1538.2, a 24.3 percent reduction. Mean total output tokens fell from 2652.2 to 2236.7, a 15.7 percent reduction.">
        <article className="bar-study">
          <header>
            <div>
              <span className="chart-kicker">MEAN TOKENS · 0–2,200</span>
              <h3>Reasoning trace</h3>
            </div>
            <strong>−24.3%</strong>
          </header>
          <div className="bar-axis"><span>0</span><span>1,100</span><span>2,200</span></div>
          <div className="bar-line">
            <span className="bar-label">Base</span>
            <i className="bar base" style={{ "--bar-width": "92.35%" } as React.CSSProperties} />
            <b>2031.8</b>
          </div>
          <div className="bar-line">
            <span className="bar-label">Adaptive</span>
            <i className="bar adaptive" style={{ "--bar-width": "69.92%" } as React.CSSProperties} />
            <b>1538.2</b>
          </div>
        </article>

        <article className="bar-study">
          <header>
            <div>
              <span className="chart-kicker">MEAN TOKENS · 0–2,800</span>
              <h3>Total output</h3>
            </div>
            <strong>−15.7%</strong>
          </header>
          <div className="bar-axis"><span>0</span><span>1,400</span><span>2,800</span></div>
          <div className="bar-line">
            <span className="bar-label">Base</span>
            <i className="bar base" style={{ "--bar-width": "94.72%" } as React.CSSProperties} />
            <b>2652.2</b>
          </div>
          <div className="bar-line">
            <span className="bar-label">Adaptive</span>
            <i className="bar adaptive" style={{ "--bar-width": "79.88%" } as React.CSSProperties} />
            <b>2236.7</b>
          </div>
        </article>
      </div>

      <dl className="diagnostic-strip">
        <div>
          <dt>Max-token terminations</dt>
          <dd><span>94</span><i>→</i><strong>39</strong></dd>
        </div>
        <div>
          <dt>Unclosed traces</dt>
          <dd><span>46</span><i>→</i><strong>12</strong></dd>
        </div>
        <div>
          <dt>Accuracy</dt>
          <dd><span>74.5%</span><i>→</i><strong>77.0%</strong></dd>
          <small className="accuracy-method-note">
            Difference not statistically significant (McNemar p = 0.260). No accuracy improvement claimed.
          </small>
        </div>
        <div>
          <dt>Paired output delta</dt>
          <dd><strong>−415.5</strong><em> tokens</em></dd>
          <small>95% CI [−484.7, −349.5]</small>
        </div>
      </dl>
    </div>
  );
}

export function FourArmStudy() {
  return (
    <details className="methodology-panel">
      <summary>
        <span>
          <small>SECONDARY BREAKDOWN</small>
          Four-arm same-base study
        </span>
        <i aria-hidden="true">+</i>
      </summary>
      <div className="table-scroll" tabIndex={0} aria-label="Scrollable four-arm results table">
        <table>
          <caption>All arms use the same Gemma 4 E2B base model and the same 400 held-out examples.</caption>
          <thead>
            <tr>
              <th scope="col">Metric</th>
              <th scope="col">Simple LoRA</th>
              <th scope="col">Adaptive LoRA</th>
              <th scope="col">Base Instruct</th>
              <th scope="col">Base Thinking</th>
            </tr>
          </thead>
          <tbody>
            <tr><th scope="row">Accuracy</th><td>74.5%</td><td>77.0%</td><td>74.5%</td><td>74.5%</td></tr>
            <tr><th scope="row">Mean output tokens</th><td>1369.5</td><td>2236.7</td><td>1371.1</td><td>2652.2</td></tr>
            <tr><th scope="row">Mean thinking tokens</th><td>0.0</td><td>1538.2</td><td>0.0</td><td>2031.8</td></tr>
            <tr><th scope="row">Max-token hits</th><td>4</td><td>39</td><td>6</td><td>94</td></tr>
            <tr><th scope="row">Unclosed thinking traces</th><td>0</td><td>12</td><td>0</td><td>46</td></tr>
          </tbody>
        </table>
      </div>
      <p className="method-note">
        Training used LoRA adapters. Simple LoRA is an auxiliary non-thinking control; Adaptive LoRA versus Base Thinking is the primary same-thinking-regime comparison.
      </p>
      <p className="method-note">
        Exact categorical calibration remains weak in this experiment, although a broader continuous relationship between task difficulty and reasoning expenditure remains visible.
      </p>
    </details>
  );
}
